import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
//import jobmixin from '@/helpers/Mixins/JobMixin.js';
export default {
    methods: {
        async getAllLeadTypes() {
            var meta = { clientApiMethod: 'getAllLeadTypes', input: {} }
            var response = await client().get(store.state.apiRouteRoot + "LeadType", { meta: meta })
            return response?.data;
        },
        async getLeadTypeListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getLeadTypeListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "LeadType/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getLeadType(leadTypeId) {
            var meta = { clientApiMethod: 'getLeadType', input: { leadTypeId: leadTypeId } }
            var response = await client().get(store.state.apiRouteRoot + "LeadType/" + leadTypeId, { meta: meta })
            return response?.data;
        },
        async createLeadType(newLeadType) {
            var meta = {
                clientApiMethod: 'createLeadType',
                input: { newLeadType },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'LeadType', newLeadType, { meta: meta })
            return response?.data;
        },
        async changeLeadType(updatedLeadType) {
            var meta = {
                clientApiMethod: 'changeLeadType',
                input: { updatedLeadType },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'LeadType', updatedLeadType, { meta: meta })
            return response?.data;
        },
        async deleteLeadType(leadTypeId) {
            var meta = {
                clientApiMethod: 'deleteLeadType',
                input: { leadTypeId: leadTypeId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.lead.lead_type") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "LeadType/" + leadTypeId, { meta: meta })
            return response?.data;
        },
    }
}